<template>
  <div>
    <div v-if="!isSupportedGrade && !isParentUser" class="proficiency-container">
      <div class="not-support-grade">
        <div class="title px-0">
          {{ $t('common.user_proficiency') }}
          <img 
            src="/static/images/ic-info-outline-black.svg"
            alt="classting-score"
            v-b-modal.previewProficiencyModal
          />
        </div>
        <div class="sub-title px-0">
          <span>{{ $t('common.not_support_grade') }}</span>
        </div>
      </div>
    </div>

    <template v-else>
      <CatSubtitle 
        v-if="!isParentUser"
        :title="'common.user_proficiency'" 
        :eventLabel="'levels.view_more'"
        class="cl-container"
        :routeName="'cat-proficiency'"
      />
      <div class="proficiency-container">

        <SubHeaderTab
          :items="filterSubjects"
          :selectedId="selectedSubjectId"
          @selectedTab="selectedTab"
        />

        <div class="row align-items-center">
          <CatScore
            :selectedSubjectId="selectedSubjectId"
            :selectedSubjectColor="selectedSubjectColor"
          />
          <CatRank :selectedSubjectId="selectedSubjectId" />
        </div>

        <CatRankPolicy />
      </div>
    </template>

    <b-modal
      id="previewProficiencyModal"
      class="preview-proficiency-modal"
      ref="modal"
      centered
      hide-header
      hide-footer
    >
      <slot>
        <div class="preview-proficiency">
          <div class="preview-proficiency-header">{{ $t('common.not_support_grade' )}}</div>
          <div class="preview-proficiency-body">
            <img src="/static/images/img_sample_level.png" alt="icon" />
          </div>
          <div class="preview-proficiency-footer">
            <button
              type="button"
              @click="handleCloseClick"
            >
              {{ $t('common.confirmation') }}
            </button>
          </div>
        </div>
      </slot>
    </b-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import CatRank from '../components/CatRank';
  import CatScore from '../components/CatScore';
  import CatRankPolicy from '../components/CatRankPolicy';
  import CatSubtitle from '../components/CatSubtitle';

  export default {
    name: 'cat-proficiency',

    data() {
      return {
        selectedSubjectId: 0,
        selectedSubjectColor: '#00c896',
      };
    },

    components: {
      CatRank,
      CatScore,
      CatRankPolicy,
      CatSubtitle,
    },

    computed: {
      ...mapGetters({
        isSupportedGrade: 'isSupportedGrade',
        catSubjects: 'getCatSubjects',
        filterSubjects: 'getFilterSubjects',
        isParentUser: 'isParentUser',
      }),
    },

    methods: {
      ...mapActions([
        'setSelectedSubjectId',
      ]),

      selectedTab(selected) {
        this.setSelectedSubjectId(selected.id);
        this.selectedSubjectId = selected.id;
        this.selectedSubjectColor = selected.color_code;
      },

      handleCloseClick() {
        this.$refs.modal.hide();
      },

    },
  };
</script>

<style lang="scss" scoped>

  .proficiency-container {
    max-width: 946px;
    margin: 0 auto;
    padding: 14px;

    .not-support-grade {
      padding: 24px 0px 24px 0px;

      .title {
        float: left;
        font-size: 18px;
      }

      .sub-title {
        float: right;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      }
    }

    .subject {
      text-align: center;
      display: inline-block;
      padding: 6px;
      font-weight: bold;
      cursor: pointer;
      border-bottom: 2px solid rgba(0, 0, 0, 0.2);
      color: rgba(0, 0, 0, 0.4);
      padding: 8px 44px 8px 44px;
      margin-right: 4px;

      &.active {
        color: #00C896;
        border-bottom: 2px solid #00C896;
      }
    }

    .dummy-subject {
      width: 25%;
      padding: 6px;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .preview-proficiency {
    .preview-proficiency-header {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.6);
      padding: 14px;
    }

    .preview-proficiency-body {
      img {
        width: 100%
      }
    }

    .preview-proficiency-footer {
      text-align: center;
      padding: 14px;

      button {
        border-radius: 4px;
        background-color: #00c896;
        color: #ffffff;
        border: 0;
        padding: 2% 22%;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// CatProficiency.vue?7713b019